// ======================================================================
// FILE:
// src/modules/finance/components/FinanceSummaryCards.jsx
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// COMPONENT:
// Finance Summary Cards
//
// PURPOSE:
// Displays KPI summary cards for Finance transaction screens.
//
// FEATURES:
// - Responsive
// - Bootstrap only
// - Mobile friendly
// - Reusable
//
// AUTHOR:
// DizyPro ERP
// ======================================================================

import React from "react";

// ======================================================================
// COMPONENT
// ======================================================================

export default function FinanceSummaryCards({

    cards = [],

}) {

    return (

        <div className="row g-3 mb-4">

            {
                cards.map((card) => (

                    <div
                        key={card.key}
                        className="
                            col-12
                            col-sm-6
                            col-lg
                        "
                    >

                        <div
                            className="card shadow-sm border-0 h-100"
                        >

                            <div className="card-body">

                                <div
                                    className="
                                        d-flex
                                        justify-content-between
                                        align-items-center
                                    "
                                >

                                    <div>

                                        <div
                                            className="text-muted small"
                                        >
                                            {card.title}
                                        </div>

                                        <h3
                                            className="fw-bold mb-0 mt-2"
                                        >
                                            {card.value ?? 0}
                                        </h3>

                                    </div>

                                    <div
                                        style={{
                                            width: 52,
                                            height: 52,
                                            borderRadius: 12,
                                            background: card.background,
                                            color: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: 22,
                                        }}
                                    >

                                        <i
                                            className={card.icon}
                                        />

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                ))
            }

        </div>

    );

}